import type { PortalBranding } from './branding'

// localStorage cache for the tenant branding fetched at bootstrap. Lets the
// portal paint in-brand instantly on a warm load and fall back to the last
// good config when the BE is briefly unreachable. Cache-busted on settings
// save (version bump) per the FE technical discovery, Section 5.

const cacheKey = (slug: string) => `cp:branding:${slug}`

/** Returns the cached branding for `slug` (already normalized when written). */
export const readCachedBranding = (slug: string): PortalBranding | null => {
  try {
    const raw = window.localStorage.getItem(cacheKey(slug))
    return raw ? (JSON.parse(raw) as PortalBranding) : null
  } catch {
    return null
  }
}

export const writeCachedBranding = (
  slug: string,
  branding: PortalBranding
): void => {
  try {
    window.localStorage.setItem(cacheKey(slug), JSON.stringify(branding))
  } catch {
    // Quota or unavailable storage (private mode); fall back to a live fetch.
  }
}

export const clearCachedBranding = (slug: string): void => {
  try {
    window.localStorage.removeItem(cacheKey(slug))
  } catch {
    // No-op: nothing to clear if storage is unavailable.
  }
}
